import { useContext } from "react";
import { NBoilerplateContext } from "./NBoilerplateContext";

export function useStore(selector) {
  const store = useContext(NBoilerplateContext);
  if (!store) throw new Error("NBoilerplateContext not found");
  return store(selector);
}

// Add this for direct access to the store instance:
export function useStoreInstance() {
  const store = useContext(NBoilerplateContext);
  if (!store) throw new Error("NBoilerplateContext not found");
  return store;
}

// Add this: Non-hook store access for utility functions
let _globalStoreInstance = null;

export function setGlobalStoreInstance(store) {
  _globalStoreInstance = store;
}

export function getGlobalStoreInstance() {
  if (!_globalStoreInstance) {
    throw new Error(
      "Store not initialized. Make sure to call setGlobalStoreInstance() first."
    );
  }
  return _globalStoreInstance;
}
